import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pricing"
export default class extends Controller {
  static targets = ["button", "creditAmount", "price", "hiddenAmount", "timer"]

  connect() {
    // Find the $25 package button
    const defaultButton = this.buttonTargets.find(button => parseInt(button.dataset.amount) === 25)
    if (defaultButton) {
      this.selectPackage({ target: defaultButton })
    }
    this.startCountdown()
  }

  selectPackage(event) {
    const button = event.target.closest("[data-pricing-target='button']")
    if (!button) return

    const amount = parseInt(button.dataset.amount)
    const credits = this.calculateCredits(amount)

    this.buttonTargets.forEach(btn => {
      btn.classList.remove("bg-[#6C2BD9]", "scale-105", "ring-2", "selected")
      btn.classList.add("bg-gray-800/50")
    })

    button.classList.remove("bg-gray-800/50")
    button.classList.add("bg-[#6C2BD9]", "scale-105", "ring-2", "selected")

    this.creditAmountTarget.textContent = credits
    this.priceTarget.textContent = amount
    
    // Only update hidden field if it exists (user is signed in)
    if (this.hasHiddenAmountTarget) {
      this.hiddenAmountTarget.value = amount
    }
  }

  calculateCredits(amount) {
    // For amounts less than 25, return the same number of credits
    if (amount < 25) return amount
    // For 25 and above, return double the credits
    return amount * 2
  }

  startCountdown() {
    if (!this.hasTimerTarget) return

    // Calculate the end date for the current 7-day cycle
    this.calculateEndOfCurrentCycle()

    const updateTimer = () => {
      const now = new Date().getTime()
      const distance = this.endDate - now

      // If countdown is finished, recalculate for the next cycle
      if (distance <= 0) {
        this.calculateEndOfCurrentCycle()
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      this.timerTarget.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`
    }

    updateTimer()
    setInterval(updateTimer, 1000)
  }

  calculateEndOfCurrentCycle() {
    // Use UTC reference date (Jan 1, 2023 00:00:00 UTC)
    const referenceDate = Date.UTC(2023, 0, 1)
    const now = new Date().getTime() // UTC timestamp
    
    const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000
    const weeksPassed = Math.floor((now - referenceDate) / millisecondsPerWeek)
    
    // Calculate end of current UTC-aligned cycle
    this.endDate = referenceDate + ((weeksPassed + 1) * millisecondsPerWeek)
  }
}
